module.exports = __webpack_public_path__ + "img/ramses_revenge.bb0dcd44.jpg";